import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import ClientView from '@/views/ClientView.vue'
import DashboardView from '@/views/DashboardView.vue'
import HardwareView from '@/views/HardwareView.vue'
import AdminClient from '@/views/AdminClient.vue'
import DeploymentView from '@/views/DeploymentView.vue'
import AffichageTvView from '@/views/Affichage-tvView.vue'
import MaintenanceView from '@/views/MaintenanceView.vue'
import BorneAndroid from '@/views/BorneAndroid.vue'
import LanguageSelectionEditor from '@/views/LanguageSelectionEditor.vue'
import TicketDesigner from '@/views/TicketDesigner.vue'
import ScreenEditor from '@/views/ScreenEditor.vue'
import ScreenDisplay from '@/views/ScreenDisplay.vue'
import ConfigurationView from '@/views/ConfigurationView.vue'
import SuperAdminView from '@/views/SuperAdminView.vue'
import SettingsView from '@/views/SettingsView.vue'
import UserClient from '@/views/UserClient.vue'
import RapportIntervention from '@/views/RapportIntervention.vue'
import KioskView from '@/views/KioskView.vue'
import TicketTv from '@/views/TicketTv.vue'
import ScreenView from '@/views/ScreenView.vue'
import CountersUsers from '@/views/CountersUsers.vue'
import TvPersonalisation from '@/views/TvPersonalisation.vue'
import TicketView from '@/views/TicketView.vue'
import MediaLibrary from '@/views/MediaLibrary.vue'
import { isTokenExpired } from '@/utils/authCheck'
const routes = [
  { path: '/login', name: 'login', component: LoginPage },
   { path: '/client', name: 'client', component: ClientView },
   { path: '/rapport-intervention', name: 'rapport-intervention', component: RapportIntervention },
    { path: '/user-client', name: 'user-client', component: UserClient },
    { path: '/hardware', name: 'hardware', component: HardwareView },
  { path: '/', name: 'dashboard', component: DashboardView },
  { path: '/deployment', name: 'deployment', component: DeploymentView },
  { path: '/superadmin', name: 'superadmin', component: SuperAdminView },
  { path: '/settings', name: 'settings', component: SettingsView },
    { path: '/maintenance', name: 'maintenance', component: MaintenanceView },
     { path: '/maintenance/:id', name: 'configuration', component: ConfigurationView },

   { path: '/admin-client', name: 'admin-client', component: AdminClient },
    { path: '/affichage-tv', name: 'affichage-tv', component: AffichageTvView },
     { path: '/waitingRoom', name: 'waitingRoom', component: TicketTv },
      { path: '/screen', name: 'screen', component: ScreenView },
      { path: '/Counter-User', name: 'Counter-User', component: CountersUsers },
       { path: '/ticket', name: 'ticket', component: TicketView },
{
  path: '/borne-apk/:kioskId',
  name: 'KioskLayout',
  component: BorneAndroid
},
{
  path: '/language-selection/:kioskId',
  name: 'LanguageSelection',
  component: LanguageSelectionEditor
},
{
  path: '/ticket-designer/:kioskId',
  name: 'TicketDesigner',
  component: TicketDesigner
},
{
  path: '/screen-editor/:agencyId',
  name: 'ScreenEditor',
  component: ScreenEditor
},
{
  path: '/screen/:agencyId',
  name: 'ScreenDisplay',
  component: ScreenDisplay
},
      { path: '/kiosk', name: 'kiosk', component: KioskView },
       { path: '/TvPersonalisation', name: 'TvPersonalisation', component: TvPersonalisation },
  { path: '/media-library', name: 'MediaLibrary', component: MediaLibrary },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ✅ Protection des routes avec vérification d'expiration de token
router.beforeEach((to, from, next) => {
  console.log('[Router] Navigation vers:', to.path);

  // 1. Liste des pages statiques publiques
  const publicPages = ['/login', '/waitingRoom', '/waitingroom']

  // 2. On vérifie si la page actuelle est dans la liste publique
  const isPublicPage = publicPages.includes(to.path)

  // 3. Si page publique, laisser passer
  if (isPublicPage) {
    console.log('[Router] ✅ Page publique, accès autorisé');
    return next()
  }

  // 4. Récupération du token
  const token = localStorage.getItem('superAdminToken')

  // 5. Vérifier la présence du token
  if (!token) {
    console.warn('[Router] ⚠️ Aucun token, redirection vers /login');
    return next('/login')
  }

  // 6. Vérifier l'expiration du token
  if (isTokenExpired(token)) {
    console.warn('[Router] ⚠️ Token expiré, redirection vers /login');
    localStorage.removeItem('superAdminToken');
    return next('/login')
  }

  // 7. Token valide, autoriser la navigation
  console.log('[Router] ✅ Token valide, accès autorisé');
  next()
})

export default router
